import { render } from "./ExportTable.vue?vue&type=template&id=f4e0ea38"
import script from "./ExportTable.vue?vue&type=script&lang=ts"
export * from "./ExportTable.vue?vue&type=script&lang=ts"
script.render = render

export default script